import React, { useState } from 'react';
import { TabPanel, Tabs } from '@paypalcorp/pp-react';
import styles from './DynamicTabs.module.less';
import componentMap from '../../Page/pageComponentMap';
import { trackTabClick } from '../../lib/fpti';

const DynamicTabs = ({ ecmContent }) => {
  const { content } = ecmContent;
  const tabsList = [];
  const tabContent = {};

  content.forEach((tab) => {
    const { name, key } = tab.content;
    const PageComponent = componentMap.get(key) || (() => <></>);
    const componentProps = {
      ecmContent: tab
    };
    tabContent[name] = <PageComponent {...componentProps} />;
    tabsList.push({
      panelId: name,
      label: name
    });
  });

  const [selectedTabIdx, setSelectedTabIdx] = useState(0);

  return (
    <div>
      <Tabs
        tabs={tabsList}
        selectedTabIdx={selectedTabIdx}
        onClick={(e, idx) => {
          setSelectedTabIdx(idx);
          trackTabClick(tabsList[idx].label);
        }}
        className={styles.tabs}
      >
        {tabsList.map((tab) => (
          <TabPanel
            id={tab.panelId}
            tabId={tab.panelId}
            className={styles.tab_panel}
            key={tab.panelId}
          >
            {tabContent[tab.panelId]}
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default DynamicTabs;
